import { Component } from "@angular/core";
import { LoadingService } from "../../services/loading.service";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";


@Component({
    selector: "app-loading-spinner",
    templateUrl: "./loading-spinner.component.html",
    styleUrls: ["./loading-spinner.component.scss"],
    imports: [MatProgressSpinnerModule]
})
export class LoadingSpinnerComponent {
    public active!: boolean;

    public constructor(private spinner: LoadingService) {
        spinner.loading$.subscribe((status: boolean) => {
            this.active = status;
        });
    }

    ngOnInit() {}

    ngOnDestroy() {
        this.spinner.loadingOff(false);
    }
}
